<!-- Content -->
<div class="content container-fluid">
  <booking-show-modal [bookingId]="bookingId$ | async"></booking-show-modal>
</div>
